import { createSelector } from 'reselect';
import ItemsWithHandoverDataRoadDetailsColumns
  from '../../containers/ItemsWithHandoverDataRoadDetailsColumns';
import ReportDefinitions from '../../../../../../common/config/ReportDefinitions';

export const getGeneratedOnDateTime =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.metadata.generatedOnDateTime;

export const getIsLoading =
  state => state.reporting
    .ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.isLoading;

export const getData =
  ReportDefinitions
    .ITEMS_WITH_HANDOVER_DATA_ROAD_DETAILS.getDataFunction();

export const getColumns =
  createSelector(getData, ItemsWithHandoverDataRoadDetailsColumns);
